export default "__VITE_ASSET__BkiFUPi9__"